var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtpValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54545 14L11.8182 17.2727L19.4545 9.63636M22.7273 17.2727C21.6364 18.3636 24.0909 21.3636 22.7273 22.7273C21.3636 24.0909 18.3636 21.6364 17.2727 22.7273C16.1818 23.8182 15.6364 26 14 26C12.3636 26 11.8182 23.8182 10.7273 22.7273C9.63636 21.6364 6.63636 24.0909 5.27273 22.7273C3.90909 21.3636 6.36364 18.3636 5.27273 17.2727C4.18182 16.1818 2 15.6364 2 14C2 12.3636 4.18182 11.8182 5.27273 10.7273C6.36364 9.63636 3.90909 6.63636 5.27273 5.27273C6.63636 3.90909 9.63636 6.36364 10.7273 5.27273C11.8182 4.18182 12.3636 2 14 2C15.6364 2 16.1818 4.18182 17.2727 5.27273C18.3636 6.36364 21.3636 3.90909 22.7273 5.27273C24.0909 6.63636 21.6364 9.63636 22.7273 10.7273C23.8182 11.8182 26 12.3636 26 14C26 15.6364 23.8182 16.1818 22.7273 17.2727Z",
    stroke: "#FEFEFE",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpValidation);
export default __webpack_public_path__ + "static/media/otp-validation.9b21fc74b7e70facaba7f48853aea22b.svg";
export { ForwardRef as ReactComponent };